import { matchRoutes } from "react-router";
import { ADMIN_ROUTE_PAGES } from "@shared/admin-route-pages";

/** Each ADMIN_ROUTE_PAGES page and every route under it, as React Router route objects. */
const ADMIN_ROUTES = ADMIN_ROUTE_PAGES.flatMap((page) => [{ path: page }, { path: `${page}/*` }]);

/**
 * #4733 round 3: true when React Router would route this pathname to an
 * ADMIN_ROUTE_PAGES page or a route under it. It asks React Router's own
 * matcher, which ignores case and decodes each segment, so `/ADMIN/ai-feedback`
 * and `/admin/%61i-feedback` are the admin route here too. The dark sweep
 * reads the same list (isAdminRoutePage) on its clean page keys.
 */
export function matchesAdminRoute(pathname: string): boolean {
  return matchRoutes(ADMIN_ROUTES, pathname) !== null;
}
